"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasLanguageInUrl = void 0;
var _getLanguageCodeAbbreviation = require("./getLanguageCodeAbbreviation");
/**
 * Checks if current pathname has one of available languages present
 */
const hasLanguageInUrl = availableLanguages => {
  /**
   * First part of pathname that can have one of available languages
   */
  const firstPartOfPathname = typeof window === 'undefined' ? undefined : window.location.pathname.split('/').at(1);
  return availableLanguages.findIndex(item => (0, _getLanguageCodeAbbreviation.getLanguageCodeAbbreviation)(item.code ?? '') === firstPartOfPathname) !== -1;
};
exports.hasLanguageInUrl = hasLanguageInUrl;